import {Injectable, TemplateRef, ViewContainerRef} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ReplaySubject} from "rxjs";
import {SimpleModalEnum} from "../enums/enums";
import SimpleModalDto from "../dto/simple-modal-dto";

@Injectable({
  providedIn: 'root'
})
export class SimpleModalService {
  constructor() {
  }

  message: ReplaySubject<SimpleModalDto> = new ReplaySubject<SimpleModalDto>(1);
  closeResult = '';

  getMessage$(){
    return this.message.asObservable();
  }

  /**
   * Opens a confirmation modal and returns a promise that resolves true if the modal
   *
   * @param title
   * @param body
   */
  openConfirmPromisified(title: string = "", body: string = ""): Promise<boolean>{
    return new Promise<boolean>(res => this.openConfirm(title, body, () => res(true), () => res(false)))
  }

  openConfirm(title: string = "", body: string = "", confirmAction: null|(() => void) = null, cancelAction: null|(() => void) = null) {
    this.message.next({
      type : SimpleModalEnum.CONFIRM,
      body : body,
      title : title,
      confirmAction : confirmAction,
      cancelAction : cancelAction
    });
  }
}
